export enum Sort{
  Latest = "Latest",
  Highest = "Highest",
  Lowest = "Lowest",
  Undefined = 'Undefined'
}
